// extracted by mini-css-extract-plugin
export default {"SearchBar":"Search_SearchBar__hAvZe"};